import style from './Footer.module.css'

export function Footer() {
  return (
    <div>
        <div className={style.down_bar}>
          <span>&copy;Akaz Marinho da Silva</span>
          <span>Desenvolvedor fullstack</span>
        </div>
    </div>
  )
}
